/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {CriterionBaseContract} from '../../api/contracts/criterion-base.contract';
import {CriterionBaseModel} from './criterion-base.model';


export class CriterionBaseMapper {
    static fromCriterionBaseContractArray(input: CriterionBaseContract[]): CriterionBaseModel[] {
        return input?.map((element) => CriterionBaseMapper.fromCriterionBaseContract(element));
    }

    static fromCriterionBaseContract(input: CriterionBaseContract): CriterionBaseModel {
        let model: CriterionBaseModel;

        if (input != null) {
            model = {
                value: input.value,
                specCode: input.specCode
            };
        }
        return model;
    }
}
